import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { CtaLink } from 'shared/components'

type NotFoundProps = {
	title: string
	description: string
	backTo: string
	backText: string
}

export const NotFound = ({ title, description, backTo, backText }: NotFoundProps) => (
	<div className="mx-auto max-w-[704px] px-5 lg:px-0">
		<div className="rounded-lg border border-border bg-card p-10 text-center shadow-panel">
			<h1 className="font-display text-xl font-bold text-foreground">{title}</h1>
			<p className="mt-2 text-[13px] text-muted-foreground">{description}</p>
			<CtaLink
				className="mt-6"
				to={backTo}
				text={backText}
				icon={<ArrowLeftIcon />}
				variant="outline"
			/>
		</div>
	</div>
)
